import CheckcircleIcon from 'icons/Checkcircle.icon';
import SendIcon from 'icons/Send.icon';
import WarningExclamationIcon from 'icons/WarningExclamation.icon';
import XcircleIcon from 'icons/Xcircle.icon';
import { IconProp } from 'models/Icon';
import {
  DATA_ROOM_NDA_SIGNING_STATUS,
  DataRoomNdaSigningStatus,
} from 'router/subrouters/DataRoom/models/DataRoomNDA';

export const NDA_COPIES: Record<DataRoomNdaSigningStatus, string> = {
  [DATA_ROOM_NDA_SIGNING_STATUS.PENDING]: 'sentNDA',
  [DATA_ROOM_NDA_SIGNING_STATUS.NDA_EXECUTED]: 'signedNDA',
  [DATA_ROOM_NDA_SIGNING_STATUS.COUNTER_SIGNATURE_PENDING]: 'ndaCounterPending',
  [DATA_ROOM_NDA_SIGNING_STATUS.NOT_SENT]: 'notSentNDA',
  [DATA_ROOM_NDA_SIGNING_STATUS.REJECTED]: 'ndaRejected',
} as const;

export const NDA_ICON: Record<DataRoomNdaSigningStatus, IconProp> = {
  [DATA_ROOM_NDA_SIGNING_STATUS.PENDING]: SendIcon,
  [DATA_ROOM_NDA_SIGNING_STATUS.NDA_EXECUTED]: CheckcircleIcon,
  [DATA_ROOM_NDA_SIGNING_STATUS.NOT_SENT]: WarningExclamationIcon,
  [DATA_ROOM_NDA_SIGNING_STATUS.REJECTED]: XcircleIcon,
  [DATA_ROOM_NDA_SIGNING_STATUS.COUNTER_SIGNATURE_PENDING]:
    WarningExclamationIcon,
} as const;
